<button
  class="app-button app-button--{{ variant }} app-button--{{ size }}"
  [class.app-button--full]="fullWidth"
  [disabled]="disabled"
  (click)="onClickButton()"
>
  <ng-content></ng-content>
</button>
